export default {"src":"/_next/static/media/revalidation.e34b04b2.svg","height":448,"width":448,"blurWidth":0,"blurHeight":0};